import * as _ from "underscore";
import * as React from "react";
import { connect } from "react-redux";
import { Panel } from "react-bootstrap";
import { Button } from "carbon-components-react";
import { Save16 } from "@carbon/icons-react";

import HurdleView from "underwriter_dashboard/shared/HurdleView";
import { HurdleProps } from "underwriter_dashboard/HurdleEditor";
import APIClient from "../../../APIClient";
import Money from "../../../Money";
import { loadApp } from "../../actions";
import { calculateSumForEmployments, calculateSumForEmployment } from "../Income/shared";

import EmploymentSection from "./EmploymentSection";
import { addIncomeMapToEmployments } from "../Income/helpers";
import { filterAndSortSalariedCurrentEmployments } from "../Income/data-helpers";

require(`../../../../assets/stylesheets/components/underwriter_dashboard/hurdle_editors/\
salaried_income.scss`);

const styles = require("underwriter_dashboard/hurdle_editors/styles.module.scss");

/* SalariedIncomeHurdleEditor */
interface HurdleEditorProps extends HurdleProps {
  dispatch?: Function;
}

class SalariedIncomeHurdleEditor extends React.Component<HurdleEditorProps, any> {
  constructor(props) {
    super(props);

    const { app } = this.props;
    const { employments } = app;

    this.state = {
      employments: addIncomeMapToEmployments(
        filterAndSortSalariedCurrentEmployments(app, employments),
      ),
    };
  }

  onSave() {
    const aggregations = [];
    for (const i in this.state.employments) {
      const employment = this.state.employments[i];
      for (const j in employment.income_aggregations) {
        aggregations.push(employment.income_aggregations[j]);
      }
    }

    APIClient.put(`/${this.props.app.id}/paystub_income_aggregations`, {
      income_aggregations: aggregations,
    }).then(() => {
      loadApp(this.props.dispatch, this.props.app.id);
    });
  }

  updateIncomeAggregation(empIndex, aggIndex, field, value) {
    const newState = this.state;
    newState.employments[empIndex].income_aggregations[aggIndex][field] = value;
    this.setState(newState);
  }

  render() {
    const { app, hurdle, onHide, hideTitle } = this.props;

    return (
      <HurdleView app={app} hurdle={hurdle} onHide={onHide} hideTitle={hideTitle}>
        {this.renderSummarySection()}
        {this.renderEmploymentSection()}
        <footer className={styles.footer}>
          <Button kind="secondary" onClick={onHide}>
            Cancel
          </Button>
          <Button kind="primary" onClick={this.onSave.bind(this)} renderIcon={Save16}>
            Save changes
          </Button>
        </footer>
      </HurdleView>
    );
  }

  renderEmploymentSection() {
    return (
      <div className="container-fluid">
        {this.state.employments &&
          this.state.employments.map((employment, i) => (
            <EmploymentSection
              update={this.updateIncomeAggregation.bind(this, i)}
              app={this.props.app}
              employment={employment}
              key={i}
            />
          ))}
      </div>
    );
  }

  renderSummarySection() {
    const { employments } = this.state;

    const borrower1Employments = employments.filter(employment => employment.borrower_entity === 1);
    const borrower2Employments = employments.filter(employment => employment.borrower_entity !== 1);

    const total = (
      <span>
        Salaried Totals: <Money value={calculateSumForEmployments(employments)} />
      </span>
    );

    return (
      <div className="container-fluid">
        <Panel className="employments" defaultExpanded>
          <Panel.Heading>
            <Panel.Title toggle>{total}</Panel.Title>
          </Panel.Heading>
          <Panel.Collapse>
            <Panel.Body>
              <h2>
                Borrower 1: <Money value={calculateSumForEmployments(borrower1Employments)} />
              </h2>
              {borrower1Employments &&
                borrower1Employments.map((employment, i) => (
                  <div key={i}>
                    <h3>
                      {employment.name}: <Money value={calculateSumForEmployment(employment)} />
                    </h3>
                    <dl className="dl-horizontal">
                      {employment.income_aggregations &&
                        employment.income_aggregations.map((aggregation, j) => {
                          const payValue = aggregation.include_in_ratios
                            ? aggregation.monthlyIncomeMap[aggregation.calculation_method]
                            : 0;
                          return [
                            <dt key={2 * j}>{aggregation.pay_type}</dt>,
                            <dd key={2 * j + 1}>
                              <Money value={payValue} />
                            </dd>,
                          ];
                        })}
                    </dl>
                  </div>
                ))}
              {borrower2Employments.length > 0 && (
                <h2>
                  Borrower 2: <Money value={calculateSumForEmployments(borrower2Employments)} />
                </h2>
              )}
              {borrower2Employments.length > 0 &&
                borrower2Employments.map((employment, i) => (
                  <div key={i}>
                    <h3>
                      {employment.name}: <Money value={calculateSumForEmployment(employment)} />
                    </h3>
                    <dl className="dl-horizontal">
                      {employment.income_aggregations &&
                        employment.income_aggregations.map((aggregation, j) => {
                          const incomeVal = aggregation.include_in_ratios
                            ? aggregation.monthlyIncomeMap[aggregation.calculation_method]
                            : 0;
                          return [
                            <dt key={2 * j}>{aggregation.pay_type}</dt>,
                            <dd key={2 * j + 1}>
                              <Money value={incomeVal} />
                            </dd>,
                          ];
                        })}
                    </dl>
                  </div>
                ))}
            </Panel.Body>
          </Panel.Collapse>
        </Panel>
      </div>
    );
  }
}

export default connect()(SalariedIncomeHurdleEditor);
